import {
  requestAddressSearch,
  requestFuneralAddressSearch,
  requestAddressSearchPostCode
} from "@/apis/addressSearch_api";

const state = {
  addressSearchList: []
};

const getters = {
  getAddressSearchList(state) {
    return state.addressSearchList;
  }
};

const mutations = {
  ADDRESS_SEARCH_LIST(state, data) {
    if (data.documents === null || data.documents === undefined) {
      state.addressSearchList = data.resultFuneralAddr;
    } else {
      state.addressSearchList = data.documents;
    }
  },
  ADDRESS_SEARCH_INIT(state) {
    state.addressSearchList = null;
  }
};

const actions = {
  async REQUEST_ADDRESS_SEARCH_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await requestAddressSearch(parameter);

      commit("ADDRESS_SEARCH_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_ADDRESS_SEARCH_FUNERAL_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestFuneralAddressSearch(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }
      commit("ADDRESS_SEARCH_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_ADDRESS_SEARCH_POST_CODE({ commit }, parameter) {
    const param = {};
    try {
      commit("START_LOADING");
      const res = await requestAddressSearchPostCode(parameter);

      const { data } = res;
      if (data.documents && data.documents.length > 0) {
        if (
          data.documents[0].road_address !== null &&
          data.documents[0].road_address !== undefined
        ) {
          param.post = data.documents[0].road_address.zone_no;
        } else {
          param.post = data.documents[0].address.zip_code;
        }
        param.result = true;
      } else {
        alert(data.message);
      }
      commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      commit("END_LOADING");
    }
    return param;
  }
};

export default { mutations, state, actions, getters };
